import { formatDateShort, formatMoney } from "../../utils/format"
import BillObjectionNote from "./BillObjectionNote"
import { describeCustomerObjection, isObjectionOpen } from "./billObjectionDisplay"

// One unpaid bill from a company that bills the customer. The customer can pay
// all or part of it, or object to the amount while nothing is paid on it yet.
function CompanyBillRow({ bill, companyName, walletReady, busy, onPay, onObject }) {
  const objected = isObjectionOpen(bill)
  // Older servers sent no flags: every listed bill could be paid then.
  const canPay = bill.canPay !== false && !objected
  const canObject = bill.canObject === true

  return (
    // Two lines so the bill name keeps the width on a phone: name and amount,
    // then the date and the actions.
    <li className="rounded-xl border border-amber-100 bg-white px-2.5 py-2">
      <div className="flex items-baseline gap-2">
        <span className="min-w-0 flex-1 truncate text-xs font-semibold text-slate-800">{bill.description || "Bill"}</span>
        <span className="shrink-0 text-xs font-black tabular-nums text-slate-900">{formatMoney(bill.outstandingAmount)}</span>
      </div>
      <div className="mt-1 flex items-center gap-2">
        <span className="min-w-0 flex-1 text-[10px] text-slate-500">
          {bill.date ? formatDateShort(bill.date) : "No date"}
          {bill.isOverdue && <span className="font-bold text-rose-600"> · Overdue</span>}
        </span>
        {objected ? (
          <span className="shrink-0 rounded-lg bg-rose-50 px-2 py-1.5 text-[11px] font-bold text-rose-700">Objected</span>
        ) : (
          <span className="flex shrink-0 gap-1">
            {canObject && (
              <button
                type="button"
                onClick={() => onObject(bill)}
                disabled={busy}
                className="rounded-lg border border-rose-200 bg-white px-2 py-1.5 text-[11px] font-bold text-rose-700 transition-colors hover:bg-rose-50 disabled:cursor-not-allowed disabled:opacity-60"
              >
                Object
              </button>
            )}
            <button
              type="button"
              onClick={() => onPay(bill)}
              disabled={!canPay || !walletReady || busy}
              className="rounded-lg bg-teal-600 px-3 py-1.5 text-[11px] font-bold text-white transition-colors hover:bg-teal-700 disabled:cursor-not-allowed disabled:bg-slate-300"
            >
              Pay
            </button>
          </span>
        )}
      </div>
      <BillObjectionNote note={describeCustomerObjection(bill.objection, companyName)} />
    </li>
  )
}

export default CompanyBillRow
